const PLAYER_MARKET_STAGING_HOSTS = new Set([
  'card-profit-optimizer-staging-1057de608b48.herokuapp.com'
]);

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

export const isPlayerMarketMockupEnabled = ({
  enabled = process.env.REACT_APP_ENABLE_PLAYER_MARKET_MOCKUP,
  deployTarget = process.env.REACT_APP_DEPLOY_TARGET,
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
  nodeEnv = process.env.NODE_ENV
} = {}) => {
  if ((enabled || 'false').toLowerCase() !== 'true') {
    return false;
  }

  if (nodeEnv !== 'production') {
    return LOCAL_HOSTS.has(hostname);
  }

  return deployTarget === 'staging' && PLAYER_MARKET_STAGING_HOSTS.has(hostname);
};

export const isQuickFlipSearchEnabled = ({
  enabled = process.env.REACT_APP_ENABLE_QUICK_FLIP
} = {}) => String(enabled ?? 'true').toLowerCase() === 'true';
